<template>
  <div class="sc-chat-window" :class="{opened: widget.isOpen, closed: !widget.isOpen}">
    <chat-header>
      <template>
        <slot name="header"/>
      </template>
    </chat-header>
    <slot v-if="widget.screen === 'prechat'" name="pre-chat"/>
    <messages v-show="['prechat', 'postchat', 'webview'].indexOf(widget.screen) === -1 && chat.connectionState === 3">
      <template v-slot:user-avatar="scopedProps">
        <slot name="user-avatar" :user="scopedProps.user" :message="scopedProps.message"/>
      </template>
    </messages>
    <connection-lost-icon v-if="widget.screen !== 'prechat' && widget.screen !== 'postchat' && chat.connectionState !== 3"/>
    <slot v-if="widget.screen === 'postchat'" name="post-chat"/>
    <user-input v-if="['prechat', 'postchat', 'webview'].indexOf(widget.screen) === -1 && chat.connectionState === 3" />
    <webview v-if="widget.screen === 'webview'"/>
  </div>
</template>

<script>
import ChatHeader from './ChatHeader.vue'
import Messages from './Messages.vue'
import UserInput from './UserInput.vue'
import ConnectionLostIcon from './icons/ConnectionLostIcon'
import Webview from './Webview.vue'
export default {
  name: 'ChatWindow',
  components: {
    ChatHeader,
    Messages,
    UserInput,
    ConnectionLostIcon,
    Webview
  },
  inject: {
    chat: {
      type: Object
    },
    widget: {
      type: Object
    }
  }
}
</script>
<style scoped>
.sc-chat-window {
  width: 370px;
  height: calc(100% - 120px);
  max-height: 590px;
  position: fixed;
  right: 25px;
  bottom: 100px;
  box-sizing: border-box;
  box-shadow: 0px 7px 40px 2px rgba(148, 149, 150, 0.1);
  background: white;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-radius: 10px;
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  animation: fadeIn;
  animation-duration: 0.3s;
  animation-timing-function: ease-in-out;
  z-index: 10000;
}

.sc-chat-window.closed {
  opacity: 0;
  display: none;
  bottom: 90px;
}

@keyframes fadeIn {
  0% {
    display: none;
    opacity: 0;
  }

  100% {
    display: flex;
    opacity: 1;
  }
}

.sc-message--me {
  text-align: right;
}
.sc-message--them {
  text-align: left;
}

@media (max-width: 450px) {
  .sc-chat-window {
    width: 100%;
    height: 100%;
    max-height: 100%;
    right: 0px;
    bottom: 0px;
    border-radius: 0px;
  }
  .sc-chat-window {
    transition: 0.1s ease-in-out;
  }
  .sc-chat-window.closed {
    bottom: 0px;
  }
}
</style>
